// react
import { useEffect, useState, Dispatch, SetStateAction, useRef } from "react";
import { useTranslation } from "react-i18next";
// node-module
import axios, { AxiosResponse } from "axios";
import get from "lodash/get";
// mui
import {
  AccordionDetails,
  Accordion,
  AccordionSummary,
  PopoverOrigin,
  Popover,
  IconButton,
  DialogActions,
  Button,
  DialogContentText,
  TextField,
  FormControl,
  Typography,
  useTheme,
  styled,
  Autocomplete,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Dialog,
  DialogTitle,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import { LoadingButton } from "@mui/lab";
// src
import { Common } from "../../../common/src";
import { config } from "../../config/config";
import { unzip } from "unzipit";
import Spacer from "../Spacer";
import IOSSwitch from "../IOSSwitch";
import {
  coordinateSystem as coordinateSystemData,
  verticalShift,
} from "../../config/SelectListData";

// fontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { pjNameValidationCheck } from "../Utility/ValidationUtil";
import CoordinateSystemJobSite from "./parts/CoordinateSystemJobSite";
import {
  checkPermissionUploadGroupware,
  fetchJobSiteCoordinateSystem,
} from "../../api/project";
import { ECoordinateOptions, ProjectViDoc } from "../../../common/src/modules";
import Radio from "@mui/material/Radio";
import { formatFileSize } from "../../utils/file";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { red } from "@mui/material/colors";

type UploadProps = {
  setErrorSnackbar: Dispatch<SetStateAction<boolean>>;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setOpenWarning: Dispatch<SetStateAction<boolean>>;
  setMsgWarning: Dispatch<SetStateAction<string>>;
  setProgressDialog: Dispatch<SetStateAction<boolean>>;
  setUploadResult: Dispatch<SetStateAction<boolean>>;
  setUpLoadingPercent: Dispatch<SetStateAction<number>>;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
  openDialog: boolean;
  setIsShortageImageDialog: Dispatch<SetStateAction<boolean>>;
};

const UploadFileDialog = ({
  setErrorSnackbar,
  setErrorMsg,
  setOpenWarning,
  setMsgWarning,
  setProgressDialog,
  setUploadResult,
  setUpLoadingPercent,
  setOpenDialog,
  openDialog,
  setIsShortageImageDialog,
}: UploadProps) => {
  const { t } = useTranslation();
  const [whileLoading, setWhileLoading] = useState(false);
  const [file, setFile] = useState<File>();
  const [projectName, setProjectName] = useState<string>("");
  const [jobsiteId, setJobsiteId] = useState<string>("");
  const [timeStamp, setTimeStamp] = useState<number>(0);
  const [useArmarker, setUseArmarker] = useState<string>("false");
  const [jobsiteList, setJobsiteList] = useState<Common.LandlogJobSite[]>([]);
  const [fileSelected, setFileSelected] = useState(false);
  const [importFileName, setImportFileName] = useState<string>("");
  const [FileSize, setFileSize] = useState<string>("");
  // Importボタン制御
  const [pNameCheck, setPNameCheck] = useState<boolean>(true);
  const [uploadCheck, setUploadCheck] = useState(true);
  const [loadingFile, setLoadingFile] = useState<boolean>(false);
  const [isValid, setIsValid] = useState(true);
  const directoryName = importFileName;
  // dashboard連携
  const [isCoordinateSetting, setIsCoordinateSetting] = useState<boolean>(true);
  const [isLinkDashboard, setIsLinkDashboard] = useState<boolean>(false);
  const [shouldInterpolate, setShouldInterpolate] = useState<boolean>(true);
  const [selectedJobsiteCoordinateSystem, setSelectedJobsiteCoordinateSystem] =
    useState<ProjectViDoc | null>(null);
  const [coordinateSystemLoading, setCoordinateSystemLoading] =
    useState<boolean>(false);
  const [selectedDestData, setSelectedData] = useState<any[]>([
    { id: "horizontal", value: "", label: "" },
    { id: "vertical", value: "", label: "" },
  ]);
  const [selectedCoordinateOption, setSelectedCoordinateOption] =
    useState<ECoordinateOptions | null>(null);
  const [isWarningUploadDialog, setIsWarningUploadDialog] =
    useState<boolean>(false);
  const [isCheckPermissionErrorDialog, setIsCheckPermissionErrorDialog] =
    useState<boolean>(false);

  window.addEventListener("focus", function () {
    if (!openDialog) {
      document.body.style.cssText = "";
    }
  });

  useEffect(() => {
    // jobsiteデータ取得
    let apiUrl = `${config.serverHost}/api/v1/sites`;
    axios
      .get(apiUrl, {
        withCredentials: true,
      })
      .then((res: AxiosResponse<Common.LandlogJobsitesInfo>) => {
        setJobsiteList(res.data.sites);
      });
  }, []);

  useEffect(() => {
    //インポート可否チェック
    if (
      (fileSelected &&
        jobsiteId &&
        projectName &&
        isValid &&
        ((selectedCoordinateOption === ECoordinateOptions.PUBLIC_COORDINATE &&
          selectedDestData.find((item) => item.id === "horizontal").value !==
            "" &&
          selectedDestData.find((item) => item.id === "vertical").value !==
            "") ||
          (selectedCoordinateOption === ECoordinateOptions.DASHBOARD &&
            selectedJobsiteCoordinateSystem))) ||
      (fileSelected &&
        jobsiteId &&
        projectName &&
        isValid &&
        selectedCoordinateOption === ECoordinateOptions.NONE)
    ) {
      setUploadCheck(false);
      setPNameCheck(false);
    } else {
      setUploadCheck(true);
      setPNameCheck(true);
    }
  }, [
    fileSelected,
    jobsiteId,
    projectName,
    isValid,
    selectedDestData,
    selectedCoordinateOption,
    selectedJobsiteCoordinateSystem,
  ]);

  useEffect(() => {
    if (openDialog) {
      handleOpen();
    }
  }, [openDialog]);

  const currentControllerRef = useRef<AbortController | null>(null);
  const selectedCoordinateOptionRef = useRef(selectedCoordinateOption);

  useEffect(() => {
    selectedCoordinateOptionRef.current = selectedCoordinateOption;
  }, [selectedCoordinateOption]);

  useEffect(() => {
    const getJobSiteInfo = async (controller: AbortController) => {
      console.log("sl:", selectedCoordinateOption);
      try {
        setSelectedJobsiteCoordinateSystem(null);
        if (jobsiteId) {
          setCoordinateSystemLoading(true);
          const coordinateSystem = await fetchJobSiteCoordinateSystem(
            controller,
            {
              jobsiteId,
            },
          );

          if (controller.signal.aborted) {
            return;
          }

          setSelectedJobsiteCoordinateSystem(coordinateSystem || null);
          if (
            !coordinateSystem &&
            selectedCoordinateOptionRef.current ===
              ECoordinateOptions.DASHBOARD &&
            !controller.signal.aborted
          ) {
            setIsCoordinateSetting(false);
            setIsLinkDashboard(false);
            setSelectedCoordinateOption(ECoordinateOptions.PUBLIC_COORDINATE);
          }
        }
      } catch (e: any) {
        if (
          e.message !== "canceled" &&
          selectedCoordinateOptionRef.current ===
            ECoordinateOptions.DASHBOARD &&
          !controller.signal.aborted
        ) {
          setSelectedJobsiteCoordinateSystem(null);
          setIsCoordinateSetting(false);
          setIsLinkDashboard(false);
          setSelectedCoordinateOption(ECoordinateOptions.PUBLIC_COORDINATE);
        }
        console.log(e);
      } finally {
        if (!controller.signal.aborted) {
          setCoordinateSystemLoading(false);
        }
      }
    };

    if (currentControllerRef.current) {
      currentControllerRef.current.abort();
    }

    const controller = new AbortController();
    currentControllerRef.current = controller;

    getJobSiteInfo(controller);

    return () => {
      controller.abort();
      currentControllerRef.current = null;
    };
  }, [jobsiteId]);

  const jobsite = jobsiteList
    ? jobsiteList.map((data) => ({
        value: data.id,
        label: data.name,
      }))
    : [];

  const handleOpen = async () => {
    const apiUrl = `${config.serverHost}/api/v1/user/setting`;

    const fetchData = async () => {
      try {
        const res = await axios.get(apiUrl, { withCredentials: true });
        setIsCoordinateSetting(res.data.coordinateSetting);
        setIsLinkDashboard(res.data.linkDashboard);
      } catch (e) {
        console.error(e);
      }
    };

    await fetchData();
    setIsValid(true);
    setShouldInterpolate(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setImportFileName("");
    setFileSize("");
    setFileSelected(false);
    setJobsiteId("");
    setProjectName("");
    const scrollY = document.body.style.top;
    document.body.style.cssText = "";
    window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
  };

  const getFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files.length === 0) return;
    setLoadingFile(true);
    const file: File = e.target.files[0];

    try {
      const { entries } = await unzip(file);
      Object.entries(entries).forEach(async ([name, entry]) => {
        if (name.includes("catchLog.ndjson")) {
          const data = await entry.text();
          const lines = data.split("\n");
          for (const line of lines) {
            try {
              if (!line.trim()) continue;

              const json = JSON.parse(line);

              if (json.init) {
                let init = json.init;

                // 👇 handle cả 2 format
                if (typeof init === "string") {
                  init = JSON.parse(init);
                }

                if (init.time) {
                  setTimeStamp(Number(init.time) * 1000);
                  break;
                }
              }
            } catch (e) {
              console.warn("Skip invalid line:", line);
            }
          }
        }
      });

      setFile(file);
      setImportFileName(file.name);
      setFileSize(formatFileSize(file.size));
      if (e.target.files[0].name !== "" && e.target.files[0].size !== 0) {
        setFileSelected(true);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingFile(false);
    }
  };

  const getValueSelect = (type: string) => {
    const value = selectedDestData?.find((x) => x.id === type)?.value;
    return (
      (type === "horizontal" ? coordinateSystemData : verticalShift).find(
        (x) => x.value === value,
      ) || null
    );
  };

  const handleUpload = async () => {
    if (!file) return;
    if (!jobsiteId) return;

    try {
      const res: AxiosResponse<any> =
        await checkPermissionUploadGroupware.uploadStatus.get(jobsiteId);
      if (res.status === 200) {
        await uploadPFile();
      } else {
        setIsCheckPermissionErrorDialog(true);
      }
    } catch (err) {
      console.error(`failed check ${err}`);
      if (axios.isAxiosError(err) && err.response?.status === 403) {
        setIsWarningUploadDialog(true);
      } else {
        setIsCheckPermissionErrorDialog(true);
      }
    }
  };

  const uploadPFile = async () => {
    setProgressDialog(true);
    setOpenDialog(false);
    setImportFileName("");
    setFileSize("");
    setFileSelected(false);
    setJobsiteId("");
    setWhileLoading(true);
    try {
      if (file) {
        const data = new FormData();
        data.append("uploadFile", file);
        data.append("projectName", projectName);
        data.append("jobsiteId", jobsiteId);
        data.append("directory", directoryName);
        data.append(
          "coordinateSetting",
          selectedCoordinateOption === ECoordinateOptions.DASHBOARD ? "1" : "0",
        );
        // data.append("sfm_engine", selectedSfmEngine);
        data.append(
          "linkDashboard",
          selectedCoordinateOption === ECoordinateOptions.DASHBOARD &&
            isLinkDashboard
            ? "1"
            : "0",
        );
        data.append("shouldInterpolate", shouldInterpolate ? "1" : "0");
        data.append("source", "web");
        data.append("coordinate_type", selectedCoordinateOption);
        if (selectedCoordinateOption === ECoordinateOptions.PUBLIC_COORDINATE) {
          data.append(
            "vertical",
            selectedDestData?.find((x) => x.id === "vertical")?.value,
          );
          data.append(
            "horizontal",
            selectedDestData?.find((x) => x.id === "horizontal")?.value,
          );
          data.append("isStereo", "0");
        } else if (
          selectedCoordinateOption === ECoordinateOptions.DASHBOARD &&
          !!selectedJobsiteCoordinateSystem
        ) {
          let keys = ["vertical", "horizontal"];
          if (selectedJobsiteCoordinateSystem?.originEasting) {
            keys = [
              "originEasting",
              "originNorthing",
              "originLatitude",
              "originLongitude",
              "scaleFactor",
              "verticalOffset",
              "inclineX",
              "inclineY",
              "rotation",
            ];
            data.append("isStereo", "1");
          } else data.append("isStereo", "0");
          keys.forEach((key) => {
            const val = get(selectedJobsiteCoordinateSystem, key, null);
            data.append(key, val);
          });
        }

        let d = new Date();
        if (timeStamp !== 0) {
          d = new Date(timeStamp);
          data.append("timeStamp", d.toISOString());
        }
        data.append("useArmarker", useArmarker);
        const timezone: number = new Date().getTimezoneOffset() * -1;
        data.append("timezone", `${timezone}`);

        await axios
          .post(`${config.serverHost}/api/v1/project`, data, {
            withCredentials: true,
            onUploadProgress: (progressEvent) => {
              let percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUpLoadingPercent(percent);
            },
          })
          .then((res) => {
            if (res.data.isShortageImage) {
              setIsShortageImageDialog(true);
              setUpLoadingPercent(0);
            } else {
              setUploadResult(true);
            }
            setProgressDialog(false);
          })
          .catch((err) => {
            if (err.response.status === 504) {
              setOpenWarning(true);
              setMsgWarning(t("SERVER_TIME_OUT"));
            } else {
              setErrorSnackbar(true);
              setErrorMsg(t("UPLOAD_FAILED"));
            }
            setWhileLoading(false);
            setProgressDialog(false);
          });
      } else {
        setErrorSnackbar(true);
        setWhileLoading(false);
        setProgressDialog(false);
        setErrorMsg(t("FILE_NOT_EXISTS"));
      }
    } catch (err) {
      setErrorSnackbar(true);
      setWhileLoading(false);
      setProgressDialog(false);
      setErrorMsg(t("UPLOAD_FAILED"));
    }
  };

  const onChangeHandle = (e: string) => {
    setProjectName(e);

    setIsValid(pjNameValidationCheck(e));
  };

  const handleWarningUploadClose = () => {
    setIsWarningUploadDialog(false);
  };

  const handleCheckPermissionErrorClose = () => {
    setIsCheckPermissionErrorDialog(false);
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customBackgroundStyles = {
    background: theme.palette.base.modal,
  };

  const customMainColor = {
    background: theme.palette.primary.main,
    boxShadow: "none",
  };

  const customAccordionBackground = {
    background: theme.palette.base.modal,
  };

  const CustomCanselButton = styled(Button)({
    background: theme.palette.base.modal,
    color: theme.palette.base.contrast,
    boxShadow: "none",
    "&:hover": {
      background: theme.palette.base.modal,
      color: theme.palette.base.contrast,
      boxShadow: "none",
    },
  });

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  type CustomPopoverProps = {
    anchorOrigin: PopoverOrigin;
    transformOrigin: PopoverOrigin;
    content: string;
  };
  const CustomPopover = ({
    anchorOrigin,
    transformOrigin,
    content,
  }: CustomPopoverProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const replaceNewLine = (s: String) => {
      return s.split("\n").map((line) => (
        <span>
          {line}
          <br />
        </span>
      ));
    };

    const open = Boolean(anchorEl);

    return (
      <div>
        <IconButton onClick={handleClick} style={{ padding: 0 }}>
          <FontAwesomeIcon icon={faCircleQuestion} style={customColor} />
        </IconButton>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          <Typography sx={{ p: 2 }} style={{ width: "600px" }}>
            {content ? replaceNewLine(content) : ""}
          </Typography>
        </Popover>
      </div>
    );
  };

  const selectedJobsiteOption =
    jobsiteId && jobsite.find((option) => option.value === jobsiteId)
      ? jobsite.find((option) => option.value === jobsiteId)
      : null;

  useEffect(() => {
    setSelectedCoordinateOption(
      isCoordinateSetting
        ? ECoordinateOptions.DASHBOARD
        : ECoordinateOptions.PUBLIC_COORDINATE,
    );
  }, [isCoordinateSetting]);

  return (
    <>
      <DialogContentText style={customColor} className="upload-file1">
        {t("PLS_SELECT_JOBSITE")}
      </DialogContentText>
      <FormControl
        variant="outlined"
        className="form-upload-input-container"
        size="small"
      >
        <Autocomplete
          value={selectedJobsiteOption}
          onChange={(event, newValue) =>
            setJobsiteId(newValue ? newValue.value : null)
          }
          options={jobsite}
          getOptionLabel={(option) => option.label}
          onInputChange={(event, newInputValue) => {
            // × ボタンで clear されたときの処理
            if (newInputValue === "") {
              setJobsiteId(null); // state を clear する
            }
          }}
          style={{ minWidth: 495 }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{ shrink: true }}
              placeholder={t("PLS_SELECT")}
              InputProps={{
                ...params.InputProps,
                style: {
                  paddingTop: 0,
                  paddingBottom: 0,
                },
              }}
            />
          )}
        />
      </FormControl>

      <CoordinateSystemJobSite
        vidocData={selectedJobsiteCoordinateSystem}
        jobsiteName={selectedJobsiteOption?.label}
        isLoading={coordinateSystemLoading}
      />

      <DialogContentText style={customColor} className="upload-file7">
        {t("PLEASE_FILE_SELECT")}
      </DialogContentText>
      {fileSelected ? (
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <LoadingButton
            style={{
              ...customMainColor,
              boxShadow: "none",
              marginTop: "10px",
              marginBottom: "15px",
              marginLeft: "30px",
            }}
            size="small"
            variant="contained"
            component="label"
            className="loading-white upload-file8"
            loading={loadingFile}
          >
            {t("FILE_CHANGE")}
            <input
              type="file"
              accept=".zip"
              onChange={(e) => getFile(e)}
              hidden
            />
          </LoadingButton>
          <DialogContentText
            style={{ ...customColor, minWidth: 0 }}
            className="upload-file7 upload-file10"
          >
            <FolderZipIcon
              style={customColor}
              sx={{
                width: "60px",
                height: "60px",
                marginLeft: "20px",
                flexShrink: 0,
              }}
            />
            <div
              id="upload-file11"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minWidth: 0,
                overflow: "hidden",
                justifyContent: "center",
              }}
            >
              <p
                id="upload-file12"
                style={{
                  margin: 0,
                  width: "100%",
                }}
                className="truncate-single-line"
              >
                {importFileName}
              </p>
              <p id="upload-file13" style={{ margin: 0, flexShrink: 0 }}>
                {FileSize}
              </p>
            </div>
          </DialogContentText>
        </div>
      ) : (
        <>
          <LoadingButton
            style={{
              ...customMainColor,
              boxShadow: "none",
              marginTop: "10px",
              marginBottom: "15px",
              marginLeft: "30px",
            }}
            size="small"
            variant="contained"
            component="label"
            className="loading-white upload-file6"
            loading={loadingFile}
          >
            {t("FILE_SELECT")}
            <input
              type="file"
              accept=".zip"
              onChange={(e) => getFile(e)}
              hidden
            />
          </LoadingButton>
        </>
      )}
      <DialogContentText style={customColor} id="upload-file14">
        {t("PLS_INPUT_PROJECT_NAME")}
      </DialogContentText>
      {isValid ? (
        <TextField
          autoFocus
          margin="dense"
          hiddenLabel
          placeholder={t("INPUT_PROJECT_NAME")}
          onChange={(e) => onChangeHandle(e.target.value)}
          type="string"
          variant="outlined"
          className="form-upload-input-container"
          InputProps={{ className: "form-upload-input" }}
        />
      ) : (
        <TextField
          error
          helperText={t("INVALID_CHARACTERS")}
          autoFocus
          margin="dense"
          hiddenLabel
          placeholder={t("INPUT_PROJECT_NAME")}
          onChange={(e) => onChangeHandle(e.target.value)}
          type="string"
          variant="outlined"
          className="form-upload-input-container"
          InputProps={{ className: "form-upload-input" }}
        />
      )}

      <DialogContentText style={customColor} id="upload-file14">
        {t("PLS_DATA_COORDINATE_SYSTEM")}
      </DialogContentText>

      <FormControl style={{ width: "100%" }}>
        <RadioGroup
          aria-labelledby="coordinate-system-selection-label"
          name="coordinateSystemOption"
          value={selectedCoordinateOption}
          onChange={(e) =>
            setSelectedCoordinateOption(e.target.value as ECoordinateOptions)
          }
        >
          <FormControlLabel
            value={ECoordinateOptions.DASHBOARD}
            control={<Radio />}
            label={t("ALIGN_SMART_DASHBOARD")}
            disabled={
              jobsiteId &&
              !selectedJobsiteCoordinateSystem &&
              !coordinateSystemLoading
            }
            style={{ marginLeft: 20 }}
          />
          {selectedCoordinateOption === ECoordinateOptions.DASHBOARD && (
            <>
              <div className="setting-select1" style={{ marginLeft: 63 }}>
                <div className="setting-text-left">
                  {t("UPLOAD_SYSTEM_SETTING")}
                </div>
                <div className="setting-text-right">
                  <CustomPopover
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    content={
                      t("UPLOAD_SETTING") +
                      "\n" +
                      t("ONLY_FOLLOWING_CASES") +
                      "\n" +
                      "・" +
                      t("WHEN_ALIGN_TO_DASHBOARD_COORDINATE_SYSTEM")
                    }
                  />
                  <Spacer height={0} width={10} />
                  <IOSSwitch
                    onChange={(e) => {
                      setIsLinkDashboard(e.target.checked);
                      if (e.target.checked) {
                        // Dashboard連携がonなら座標系連携もon
                        setIsCoordinateSetting(true);
                      }
                    }}
                    disabled={jobsiteId && !selectedJobsiteCoordinateSystem}
                    checked={isLinkDashboard}
                  />
                </div>
              </div>

              <Accordion
                disableGutters={true}
                sx={{
                  boxShadow: "none",
                  "&:before": {
                    display: "none",
                  },
                  ".MuiAccordionSummary-root": { justifyContent: "start" },
                  ...customAccordionBackground,
                }}
              >
                <AccordionSummary
                  sx={{
                    minHeight: 30,
                    height: 30,
                    padding: 0,
                    marginLeft: 6.7,
                    ".MuiAccordionSummary-content": { flexGrow: 0 },
                  }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  {"【" + t("ADVANCED_SETTINGS") + "】"}
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <div
                    className="setting-select1"
                    style={{ marginTop: 0, marginLeft: 63 }}
                  >
                    <div className="setting-text-left">
                      {t("INTERPOLATE_SETTING_C1")}
                    </div>
                    <div className="setting-text-right">
                      <CustomPopover
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        content={
                          t("INTERPOLATE_SETTING_D1") +
                          "\n" +
                          t("INTERPOLATE_SETTING_D2")
                        }
                      />
                      <Spacer height={0} width={10} />
                      <IOSSwitch
                        onChange={(e) => {
                          setShouldInterpolate(e.target.checked);
                        }}
                        checked={shouldInterpolate}
                        disabled={!isLinkDashboard}
                      />
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </>
          )}
          <FormControlLabel
            value={ECoordinateOptions.PUBLIC_COORDINATE}
            control={<Radio />}
            label={t("CHOOSE_COORD_SYSTEM")}
            style={{ marginLeft: 20 }}
          />
          {selectedCoordinateOption ===
            ECoordinateOptions.PUBLIC_COORDINATE && (
            <div className="coordinate-select">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    color:
                      theme.palette.mode === "dark" ? "#FFFFFFFF" : "#00000099",
                    margin: "0 0 8px",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    width: 135,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {t("COORDINATE_SYSTEM")}
                </div>
                <Autocomplete
                  autoHighlight={true}
                  value={getValueSelect("horizontal")}
                  size="small"
                  options={coordinateSystemData}
                  onChange={(event, data) => {
                    const newLocalizeSelect = selectedDestData.map((item) => {
                      if (item.id === "horizontal") {
                        item = { ...item, ...data };
                      }
                      return item;
                    });
                    setSelectedData(newLocalizeSelect);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      value=""
                      placeholder={t("PLS_SELECT")}
                    />
                  )}
                  sx={{ marginBottom: 1, marginLeft: "10px" }}
                  style={{ flex: 1 }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color:
                      theme.palette.mode === "dark" ? "#FFFFFFFF" : "#00000099",
                    margin: "0 0 8px",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    width: 135,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {t("VERTICAL_COORDINATE_SYSTEM")}
                </div>
                <Autocomplete
                  autoHighlight={true}
                  value={getValueSelect("vertical")}
                  size="small"
                  options={verticalShift}
                  onChange={(event, data) => {
                    const newLocalizeSelect = selectedDestData.map((item) => {
                      if (item.id === "vertical") {
                        item = { ...item, ...data };
                      }
                      return item;
                    });
                    setSelectedData(newLocalizeSelect);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      value=""
                      placeholder={t("PLS_SELECT")}
                    />
                  )}
                  style={{ flex: 1 }}
                  sx={{ marginLeft: "10px" }}
                />
              </div>
            </div>
          )}
          <FormControlLabel
            value={ECoordinateOptions.NONE}
            control={<Radio />}
            label={t("DO_NOT_TRANSFORM_COORD_SYSTEM")}
            style={{ marginLeft: 20 }}
          />
        </RadioGroup>
      </FormControl>

      <DialogActions
        style={{
          marginTop: "10px",
          justifyContent: "center",
          ...customBackgroundStyles,
        }}
      >
        <CustomCanselButton
          size="small"
          variant="contained"
          onClick={handleClose}
          id="upload-file19"
        >
          {t("CANCEL")}
        </CustomCanselButton>
        <LoadingButton
          className={`loading-white upload-check-com ${
            uploadCheck ? "upload-check1" : "upload-check2"
          }`}
          size="small"
          variant="contained"
          disabled={uploadCheck || loadingFile || pNameCheck}
          loading={whileLoading}
          onClick={handleUpload}
          style={
            uploadCheck
              ? { boxShadow: "none" }
              : { ...customMainColor, boxShadow: "none" }
          }
        >
          {t("UPLOAD")}
        </LoadingButton>
      </DialogActions>
      <Dialog
        open={isWarningUploadDialog}
        PaperProps={{
          className: "upload-finish-page",
          style: { ...customBackgroundStyles },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        <DialogTitle style={customColor} className="upload-file21">
          <WarningAmberIcon sx={{ color: red[500] }} />{" "}
          {t("WARNING_UPLOAD_TITLE")}
          <Button
            style={customColor}
            className="x-btn upload-btn"
            onClick={handleWarningUploadClose}
          >
            ×
          </Button>
          <div id="border-comm" />
        </DialogTitle>
        <div
          style={{
            margin: 0,
            display: "flex",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "24px",
            marginRight: "24px",
          }}
        >
          <DialogContentText
            style={{
              ...customColor,
              textAlign: "center",
              whiteSpace: "pre-line",
            }}
            id="upload-file20"
          >
            {t("WARNING_UPLOAD_CONTENT")}
          </DialogContentText>
        </div>

        <div
          style={{ display: "flex", marginTop: "30px", marginBottom: "5px" }}
        >
          <Button
            className="upload-file23"
            size="small"
            variant="contained"
            onClick={handleWarningUploadClose}
            sx={{
              borderColor: "black",
              backgroundColor:
                theme.palette.mode === "light" ? "white" : "black",
              color:
                theme.palette.mode === "dark"
                  ? "white !important"
                  : "black !important",
              boxShadow: "none",
              "&:hover": {
                backgroundColor:
                  theme.palette.mode === "light" ? "white" : "black",
                boxShadow: "none",
              },
            }}
          >
            {t("CANCEL")}
          </Button>

          <Button
            style={customMainColor}
            className="upload-file22"
            size="small"
            variant="contained"
            onClick={uploadPFile}
          >
            {t("YES")}
          </Button>
        </div>
      </Dialog>

      <Dialog
        open={isCheckPermissionErrorDialog}
        PaperProps={{
          className: "upload-finish-page",
          style: { ...customBackgroundStyles },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        <DialogTitle style={customColor} className="upload-file21">
          <WarningAmberIcon sx={{ color: red[500] }} />{" "}
          {t("WARNING_UPLOAD_TITLE")}
          <Button
            style={customColor}
            className="x-btn upload-btn"
            onClick={handleCheckPermissionErrorClose}
          >
            ×
          </Button>
          <div id="border-comm" />
        </DialogTitle>

        <div
          style={{
            margin: 0,
            display: "flex",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "24px",
            marginRight: "24px",
          }}
        >
          <DialogContentText
            style={{ ...customColor, textAlign: "center" }}
            id="upload-file20"
          >
            {t("GROUPWARE_AUTHORIZATION_CHECK_ERROR")}
          </DialogContentText>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "30px",
            marginBottom: "5px",
            justifyContent: "center",
          }}
        >
          <Button
            style={customMainColor}
            className="upload-file22"
            size="small"
            variant="contained"
            onClick={handleCheckPermissionErrorClose}
          >
            {t("CLOSE")}
          </Button>
        </div>
      </Dialog>
    </>
  );
};

export default UploadFileDialog;
